// @flow
import CentenaireDownload from 'components/centenaire/CentenaireDownload';
import { connect } from 'react-redux';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/centenaire/CentenaireDownload';

import { displayModal } from 'actions/modalActions';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    displayModal: (modalObject: string, content: Object, force: boolean) =>
      dispatch(displayModal(modalObject, content, force))
  })
)(CentenaireDownload);
